import React, { useState } from 'react';
import './CompensationHome.css';

// Mail Icon
const MailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const CompensationHome = ({ onSendMail }) => {
  const [activeTab, setActiveTab] = useState('monthly'); // 'monthly' or 'yearly'
  const [email, setEmail] = useState('');

  // Monthly compensation data
  const monthlyData = {
    totalCTC: 650200.00,
    breakdown: [
      { id: 1, name: 'Basic Salary', amount: 25800.00 },
      { id: 2, name: 'Conveyance Allowance', amount: 1600.00 },
      { id: 3, name: 'Employer PF', amount: 1800.00 },
      { id: 4, name: 'HRA', amount: 10320.00 },
      { id: 5, name: 'Medical Insurance', amount: 800.00 },
      { id: 6, name: 'Special Pay', amount: 13880.00 },
    ]
  };

  // Yearly compensation data (monthly * 12)
  const yearlyData = {
    totalCTC: monthlyData.totalCTC,
    breakdown: monthlyData.breakdown.map(item => ({
      ...item,
      amount: item.amount * 12
    }))
  };

  const currentData = activeTab === 'monthly' ? monthlyData : yearlyData;

  // Format currency in Indian format
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  const handleSendMail = () => {
    if (email.trim() && onSendMail) {
      onSendMail(email);
    }
  };

  return (
    <div className="compensation-home">
      {/* Header */}
      <div className="compensation-header">
        <h1>Compensation</h1>
      </div>

      {/* Content */}
      <div className="compensation-content">
        {/* Tabs */}
        <div className="compensation-tabs">
          <button
            className={`compensation-tab ${activeTab === 'monthly' ? 'active' : ''}`}
            onClick={() => setActiveTab('monthly')}
          >
            Monthly
          </button>
          <button
            className={`compensation-tab ${activeTab === 'yearly' ? 'active' : ''}`}
            onClick={() => setActiveTab('yearly')}
          >
            Yearly
          </button>
        </div>

        {/* Total CTC Card */}
        <div className="total-ctc-card">
          <span className="ctc-label">Total CTC</span>
          <span className="ctc-value">Rs. {formatCurrency(currentData.totalCTC)}</span>
        </div>

        {/* Salary Breakdown Cards */}
        <div className="salary-breakdown">
          {currentData.breakdown.map((item) => (
            <div className="salary-card" key={item.id}>
              <span className="salary-name">{item.name}</span>
              <span className="salary-amount">Rs. {formatCurrency(item.amount)}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Footer - Send Mail */}
      <div className="compensation-footer">
        <input
          type="email"
          placeholder="yourmailid@gmail.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="email-input"
        />
        <button className="send-mail-btn" onClick={handleSendMail}>
          <MailIcon />
          <span>Send Mail</span>
        </button>
      </div>
    </div>
  );
};

export default CompensationHome;

